import React, { ReactNode, useMemo } from "react";
import { useSelector } from "react-redux";

import { OnboardingRootState } from "../redux/reducers/rootReducer";
import { getSubFormData } from "../redux/selectors";

type SubformDataProviderProps = {
  formId: string;
  subFormId: string;
  children: ReactNode;
};

export const SubformDataContext = React.createContext({
  isStarted: false,
});

export const SubformDataProvider: React.FC<SubformDataProviderProps> = ({
  formId,
  subFormId,
  children,
}) => {
  const storedValues = useSelector((state: OnboardingRootState) =>
    getSubFormData(state, formId, subFormId)
  );
  const isStarted: boolean = storedValues ? storedValues.isStarted : false;

  const value = useMemo(() => ({ isStarted: isStarted }), [isStarted]);
  return <SubformDataContext.Provider value={value}>{children}</SubformDataContext.Provider>;
};
